import { Injectable } from '@angular/core';
import { SubscriptionSchedulerServiceBase } from 'src/shared/services/subscription-scheduler-service-base';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionSchedulerService extends SubscriptionSchedulerServiceBase {
    constructor() {
        super(true);
    }
}
